<script>
  import IconButton, {Icon} from '@smui/icon-button';
  import {exclude} from '@smui/common/exclude.js';
  import { Meta } from '@smui/list';
  import Textfield from '@smui/textfield';
  export let value;
  export let label;
  export let readOnly=true;
  export let autocomplete=true;
  export let visible = false;
  $: props = exclude($$props, ['label', 'value', 'readOnly', 'autocomplete']);
</script>

{#if readOnly}
<Textfield value={value} label={label} type={visible ?'text':'password'} input$autocomplete={autocomplete ? 'on' : 'off'} input$readonly class="mdc-text-field--fullwidth" {...props}/>
{:else}
<Textfield bind:value={value} label={label} type={visible?'text':'password'} input$autocomplete={autocomplete ? 'on' : 'off'} class="mdc-text-field--fullwidth" on:input on:change {...props}/>
{/if}
<Meta>
<IconButton toggle bind:pressed={visible} title="toggle visibility">
    <Icon class="material-icons" on>visibility</Icon>
    <Icon class="material-icons">visibility_off</Icon>
</IconButton>
</Meta>